import { Drawer } from 'antd';
import React from 'react';
import { CloseIcon } from '../assets/svg';

const CommonDrawer = ({
  title,
  open,
  onClose,
  children,
  width = 350,
  placement = 'right',
  getContainer,
  ...otherProps
}) => {
  return (
    <Drawer
      title={title}
      placement={placement}
      closable
      onClose={onClose}
      open={open}
      size={width}
      closeIcon={<CloseIcon />}
      maskClosable={false}
      rootClassName="common-drawer"
      classNames={{ section: 'common-drawer-section' }}
      getContainer={(trigger) =>
        typeof getContainer === 'function'
          ? getContainer(trigger)
          : trigger.parentNode
      }
      {...otherProps}
    >
      {children}
    </Drawer>
  );
};

export default CommonDrawer;
